
import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const handleImgError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    e.currentTarget.src =
      "data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'1'%20height%3D'1'%20xmlns%3D'http%3A//www.w3.org/2000/svg'%3E%3C/svg%3E";
    console.error("Failed to load background image:", e);
  };

  return (
    <section className="w-full bg-white py-12">
      <div className="max-w-4xl mx-auto px-6">
        <div className="relative">
          <img
            src="https://static.readdy.ai/image/f431233285e388c2fc3ba3a0e7c8e013/d2cae0f9fb76dd08f538de5de67dcbf2.png"
            alt="Professional Box Truck Service"
            className="w-full h-auto object-contain"
            onError={handleImgError}
          />

          <div className="absolute inset-0 flex items-center justify-center px-4 md:px-16">
            <h2 className="text-base md:text-4xl font-bold text-white leading-tight drop-shadow-2xl italic text-center max-w-3xl">
              {t('portfolio.title')}
            </h2>
          </div>

          <div className="absolute -bottom-2 md:bottom-0 left-0 right-0 px-4 pb-2 md:px-16 md:pb-16">
            <p className="text-xs md:text-xl text-white font-medium drop-shadow-2xl text-center">
              {t('portfolio.description')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
